<template>
  <div v-if="cloud" class="lite_popup lite_business_cloud_popup" @click.stop>
    <div class="lite_popup_box lite_business_cloud_box" role="dialog" aria-modal="true" :aria-label="title">
      <div class="lite_popup_title">
        <span>{{ title }}</span>
        <button type="button" class="icon white-close lite_business_close" :disabled="!!connecting"
          :aria-label="$t('language.common.close')" @click="$emit('close')"></button>
      </div>
      <div class="lite_business_cloud_content">
        <div v-html="$t('language.popup.addCloudPopup.' + cloud.description)"></div>
        <div class="lite_business_cloud_note" v-html="$t('language.popup.addCloudPopup.specialDropBoxBottom')"></div>
        <div class="lite_business_cloud_actions">
          <button type="button" :disabled="!!connecting" @click="$emit('select', 'organization')">
            <template v-if="connecting === 'organization'">{{ $t('language.common.connecting') }}<span class="cloudDotting"></span></template>
            <template v-else>{{ $t('language.popup.addCloudPopup.accessOrganization') }}</template>
          </button>
          <button type="button" class="lite_business_personal" :disabled="!!connecting" @click="$emit('select', 'personal')">
            <template v-if="connecting === 'personal'">{{ $t('language.common.connecting') }}<span class="cloudDotting"></span></template>
            <template v-else>{{ $t('language.popup.addCloudPopup.accessPersonalCloud') }}</template>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const CLOUDS = {
  OneDriveBusiness: { name: 'oneDrive4Business', description: 'specialOnedrive' },
  DropboxBusiness: { name: 'dropbox4Business', description: 'specialDropBox' },
  BoxBusiness: { name: 'boxBusiness', description: 'specialBoxBusiness' },
};

export default {
  name: 'liteBusinessCloudPopup',
  props: {
    type: { type: String, default: '' },
    connecting: { type: String, default: '' },
  },
  computed: {
    cloud() {
      return CLOUDS[this.type] || null;
    },
    title() {
      return this.cloud ? this.$t('language.common.add') + ' ' + this.$t('language.addCloud.' + this.cloud.name) : '';
    },
  },
};
</script>

<style scoped>
.lite_business_cloud_box {
  width: 635px;
  max-width: calc(100vw - 32px);
  min-height: 280px;
  max-height: calc(100vh - 32px);
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}
.lite_business_cloud_box > .lite_popup_title {
  display: flex;
  align-items: flex-start;
  flex: 0 0 auto;
  height: auto;
  min-height: 40px;
  padding: 10px 15px 10px 20px;
  box-sizing: border-box;
  line-height: 20px;
}
.lite_business_cloud_box > .lite_popup_title > span {
  flex: 1;
  min-width: 0;
  margin-right: 12px;
  overflow-wrap: anywhere;
}
.lite_business_cloud_box .lite_business_close {
  flex: 0 0 20px;
  width: 20px;
  height: 20px;
  padding: 0 !important;
  background-color: transparent;
}
.lite_business_cloud_content {
  min-height: 0;
  padding: 35px;
  overflow-y: auto;
  font-size: 14px;
  line-height: 20px;
  overflow-wrap: anywhere;
  text-align: left;
}
.lite_business_cloud_note { margin-top: 20px; }
.lite_business_cloud_actions {
  display: flex;
  flex-wrap: wrap;
  gap: 16px 40px;
  max-width: 480px;
  margin: 40px auto 0;
}
.lite_business_cloud_actions > button {
  flex: 1 1 200px;
  min-width: 0;
  min-height: 35px;
  height: auto;
  padding: 6px 10px !important;
  border: 1px solid #fff;
  border-radius: 5px;
  color: #fff;
  background: #5562b4;
  line-height: 21px;
  white-space: normal;
  overflow-wrap: anywhere;
}
.lite_business_cloud_actions > .lite_business_personal {
  color: #5562b4;
  border-color: #5562b4;
  background: #fff;
}
.lite_business_cloud_box button:disabled { cursor: default; opacity: .65; }
@media (max-width: 600px) {
  .lite_business_cloud_content { padding: 24px 20px; }
  .lite_business_cloud_actions { margin-top: 28px; }
}
</style>



// WEBPACK FOOTER //
// src/components/popup/add_cloud_popups/lite_business_cloud_popup.vue